import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export function Breadcrumb({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4 w-full">

      {/* ── MOBILE: scrollable single row ─────────────────────────── */}
      <div className="flex sm:hidden items-center overflow-x-auto no-scrollbar
                      bg-white/80 backdrop-blur-sm px-3 py-2 rounded-xl
                      border border-gray-200 shadow-sm text-xs whitespace-nowrap">
        {/* Home */}
        <Link
          to="/"
          className="flex items-center flex-shrink-0 text-gray-700 hover:text-red-600
                     transition-colors font-semibold"
        >
          <Home className="w-3.5 h-3.5 mr-0.5" />
          <span>Home</span>
        </Link>

        {items.map((item, index) => (
          <React.Fragment key={index}>
            <ChevronRight className="w-3 h-3 text-gray-400 flex-shrink-0 mx-0.5" />
            {item.href ? (
              <Link
                to={item.href}
                className="flex-shrink-0 text-gray-700 hover:text-red-600
                           transition-colors font-semibold"
              >
                {item.label}
              </Link>
            ) : (
              <span className="flex-shrink-0 text-gray-950 font-bold">
                {item.label}
              </span>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* ── DESKTOP: full breadcrumb, same as before ───────────────── */}
      <div className="hidden sm:flex items-center space-x-2 text-sm
                      bg-white/80 backdrop-blur-sm px-4 py-2 rounded-xl
                      border border-gray-200 shadow-sm w-fit">
        <Link
          to="/"
          className="flex items-center text-gray-800 hover:text-red-600
                     transition-colors font-semibold"
        >
          <Home className="w-4 h-4 mr-1" />
          Home
        </Link>

        {items.map((item, index) => (
          <React.Fragment key={index}>
            <ChevronRight className="w-4 h-4 text-gray-500" />
            {item.href ? (
              <Link
                to={item.href}
                className="text-gray-800 hover:text-red-600
                           transition-colors font-semibold"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-gray-950 font-bold">{item.label}</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
}
